module.exports = __webpack_public_path__ + "static/img/modal2.0044567.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/modal2.png
// module id = 0FBR
// module chunks = 213